import { WEB_COMPONENT_CVE_GRID } from '../../../../../../../webcomponents.constants';
import { CveGridWebComponent } from './component/CveGridWebComponent';

window.customElements.define(WEB_COMPONENT_CVE_GRID, CveGridWebComponent);

export { CveGridWebComponent };
